import { Injectable } from '@angular/core';
import { ApiHttpClientService } from '../../api-http-client.service';
import { environment } from 'src/environments/environment';
import {
  BucketFileContent,
  BucketFornecedores,
  SupplierFileList,
  SupplierFileOrder,
  SupplierFileOrderBy
} from 'src/app/models/api/exportador/supplier-file';

/**
 * Arquivos dos fornecedores no bucket, expostos pelo modulo Supplier do Exportador.
 *
 * O escopo e decidido pelo token: fornecedor so alcanca o proprio codigo,
 * funcionario alcanca todos. A tela nao repete essa regra, apenas reage.
 *
 * Nenhum metodo usa unwrap(): esta api devolve o dto cru, e nao o envelope
 * IResponse dos demais microsservicos — unwrap() lancaria erro em toda chamada.
 * Pelo mesmo motivo o toast global e desligado: ele nao le o corpo de erro
 * { "error": "..." } daqui e mostraria sempre a mensagem generica. Quem chama
 * traduz o status com mensagemDeErro().
 */
@Injectable({
  providedIn: 'root'
})
export class ApiExportadorArquivosService {

  private baseUrl = 'v1/suppliers';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.exportador)
      .useBaseUrl(this.baseUrl)
      .disableInterceptor('toast');
  }

  /** Codigos de fornecedor presentes no bucket. Fornecedor recebe apenas o proprio. */
  getFornecedores() {
    return this.controller.useLoading().get<BucketFornecedores>('bucket/fornecedores');
  }

  listFiles(codigoSap: string, orderBy: SupplierFileOrderBy, order: SupplierFileOrder, createdAfter?: string, createdBefore?: string) {
    const params: { [param: string]: string } = { orderBy, order };
    if (createdAfter) { params.createdAfter = createdAfter; }
    if (createdBefore) { params.createdBefore = createdBefore; }

    return this.controller.useLoading().get<SupplierFileList>(
      `${encodeURIComponent(codigoSap)}/files`,
      { params }
    );
  }

  /** Conteudo em texto, para a pre-visualizacao. Carrega o arquivo inteiro em memoria. */
  getFileContent(path: string) {
    return this.controller.useLoading().get<BucketFileContent>('bucket/file', { params: { path } });
  }

  downloadFile(codigoSap: string, path: string) {
    return this.controller.useLoading().get(
      `${encodeURIComponent(codigoSap)}/files/download`,
      { params: { path }, responseType: 'blob' }
    );
  }

  downloadAllZip(codigoSap: string) {
    return this.controller.useLoading().get(
      `${encodeURIComponent(codigoSap)}/files/zip`,
      { responseType: 'blob' }
    );
  }

  downloadSelectedZip(codigoSap: string, paths: string[]) {
    return this.controller.useLoading().post(
      `${encodeURIComponent(codigoSap)}/files/zip`,
      { paths },
      { responseType: 'blob' }
    );
  }

}
